import React from 'react';
import PropTypes from 'prop-types';
import storage from 'src/storage';
import { Navigate } from 'react-router';

// Decide before rendering: rendering the dashboard first fired its API calls
// with no token, and those 401s showed "Your session has ended" (ISSUE-0346).
const IsLoggedOut = ({ component: Component }) =>
  storage.getUser() ? <Component /> : <Navigate replace to="/login" />;

IsLoggedOut.propTypes = {
  component: PropTypes.elementType
};
export default IsLoggedOut;
